import React from 'react';
import PropTypes from 'prop-types';
import EquipmentUtils from '../../utils/EquipmentUtils';

class EquipmentOptionsRow extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            qtyToUse: 0
        };

        this.onQtyChange = this
            .onQtyChange
            .bind(this);
    }

    componentWillReceiveProps(newProps) {
        const {selectedOptions, equipmentOption} = newProps;

        let existingQuantity = 0;

        if (selectedOptions) {

            const existingOption = selectedOptions.find(function (element) {
                return element.code === equipmentOption.get('code');
            });

            if (existingOption && existingOption.quantity > 0) {
                existingQuantity = existingOption.quantity;
            }
        }

        const quantity = existingQuantity > 0
            ? existingQuantity
            : 0;

        this.setState({qtyToUse: quantity});
    }

    onQtyChange(e) {
        e.preventDefault();
        const {equipmentOption, workOrderActions, orderId} = this.props;
        this.setState({qtyToUse: e.target.value});
        workOrderActions.equipmentOptionQtySet(orderId, equipmentOption.get('code'), parseInt(e.target.value));
    }

    render() {
        const {equipmentOption, index, equipmentDetails} = this.props;
        if (!equipmentDetails) return null;
        const options = [];
        const maxIndex = EquipmentUtils.calculateAditionalEquipmentMax(equipmentOption, equipmentDetails.get('details'))

        for (let index = 0; index <= maxIndex; index++) {
            options.push(
                <option key={'qty_option_' + index} value={index}>
                    {index}
                </option>
            );
        }

        const qtySelect = (
            <select
                disabled={false}
                className="browser-default"
                style={{
                fontSize: '18px'
            }}
                onChange={this.onQtyChange}
                value={this.state.qtyToUse}>
                {options}
            </select>
        );

        const rowStyle = {
            paddingTop: '2px',
            paddingBottom: '2px'
        };

        return (
            <tr
                key={`option_row_${index}`}
                style={{
                rowStyle
            }}>
                <td style={{
                    width: '60%'
                }}>
                    <label>
                        {equipmentOption.get("description")}</label>
                </td>
                <td style={{
                    width: '20%'
                }}>
                    {equipmentOption.get("cost")}
                </td>
                <td style={{
                    width: '20%'
                }}>
                    {qtySelect}
                </td>
            </tr>
        );
    }
}

EquipmentOptionsRow.propTypes = {
    equipmentOption: PropTypes.object,
    //selectedOptions: PropTypes.array,
    workOrderActions: PropTypes.object,
    orderId: PropTypes.string,
    index: PropTypes.number,
    equipmentDetails: PropTypes.object
};

export default EquipmentOptionsRow;



// WEBPACK FOOTER //
// ./src/components/equipment/EquipmentOptionsRow.js